import ConvertedFrom from './convertedFrom';

export default ConvertedFrom;
